export default __webpack_public_path__ + "a1a0662b89f4182e69f9feb3b34f11d0.jpg";